import { render, staticRenderFns } from "./SavedSolutions.vue?vue&type=template&id=7208bcbc&scoped=true"
import script from "./SavedSolutions.vue?vue&type=script&lang=js"
export * from "./SavedSolutions.vue?vue&type=script&lang=js"
import style0 from "./SavedSolutions.vue?vue&type=style&index=0&id=7208bcbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7208bcbc",
  null
  
)

export default component.exports